import { render } from "./FooterIhecs.vue?vue&type=template&id=5dab7546&scoped=true"
import script from "./FooterIhecs.vue?vue&type=script&lang=js"
export * from "./FooterIhecs.vue?vue&type=script&lang=js"

import "./FooterIhecs.vue?vue&type=style&index=0&id=5dab7546&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dab7546"]])

export default __exports__